import { ComponentProps } from "react";

import styles from "./drawer-content.module.css";

export type DrawerContentProps = ComponentProps<"div">;

export const DrawerContent = ({
  children,
  className = "",
  ...props
}: DrawerContentProps) => {
  return (
    <div className={`${styles.Container} ${className}`} {...props}>
      {children}
    </div>
  );
};
